import PlantillaModal from "./PlantillaModal";
import TablaCatalogoCuentas from "./tablas/TablaCatalogoCuenta";
const ModalSeleccionCuenta = ({ 
  mostrar, 
  onClose, 
  handleSeleccionCuenta, 
  // titulo = "Seleccione una cuenta contable",
  descripcion = "Seleccione la cuenta para asignar"
}) => {
  return (
    <PlantillaModal
      mostrar={mostrar}
      onClose={onClose}
    >
      {/* <h2 className="text-xl font-semibold mb-4">{titulo}</h2> */}
      <TablaCatalogoCuentas 
        setCuentaSeleccionada={handleSeleccionCuenta} 
        descripcion={descripcion} 
      />
    </PlantillaModal>
  );
};

export default ModalSeleccionCuenta;